import { render } from "./ViewButton.vue?vue&type=template&id=afd8fe22"
import script from "./ViewButton.vue?vue&type=script&lang=js"
export * from "./ViewButton.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__